;(function () {
  var STORAGE_KEY = 'tr_footer_country_code';
  var REPAIR_SESSION_KEY = 'tr_glbe_currency_repair';
  var DEBUG = false;

  try {
    DEBUG = /[?&]localeDebug=1\b/.test(window.location.search);
  } catch (e) {}

  function log() {
    var parts = Array.prototype.slice.call(arguments).map(function (arg) {
      if (arg && typeof arg === 'object') {
        try {
          return JSON.stringify(arg);
        } catch (e) {
          return String(arg);
        }
      }
      return String(arg);
    });
    var msg = '[TR-COUNTRY] ' + parts.join(' ');
    try {
      console.log(msg);
    } catch (e) {}
    if (!DEBUG || !window.__trLocaleDebug) return;
    window.__trLocaleDebug(msg);
  }

  function getCookie(name) {
    var pattern = '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)';
    var match = document.cookie.match(new RegExp(pattern));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function parseGlobalEData() {
    var raw = getCookie('GlobalE_Data');
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (e) {
      try {
        return JSON.parse(decodeURIComponent(raw));
      } catch (e2) {}
    }

    return null;
  }

  function isGlobalEActive() {
    if (parseGlobalEData()) return true;
    if (typeof window.Globale !== 'undefined' || typeof window.GlobalE !== 'undefined') return true;
    if (document.querySelector('script[src*="global-e"], script[src*="globale"], [class*="glbe"], [id*="glbe"]')) {
      return true;
    }
    return false;
  }

  function getCookieDomain() {
    var host = window.location.hostname;
    if (!host || host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) return '';
    if (host.indexOf('shopifypreview.com') !== -1) return '';
    var parts = host.replace(/^www\./, '').split('.');
    if (parts.length >= 2) return '.' + parts.slice(-2).join('.');
    return '.' + host;
  }

  function countryFlagHTML(isoCode) {
    if (!isoCode || isoCode.length !== 2) return '';
    var code = isoCode.toLowerCase();
    return (
      '<img src="https://flagcdn.com/w40/' + code + '.png" srcset="https://flagcdn.com/w80/' +
      code + '.png 2x" alt="" width="20" height="15" loading="lazy" style="display:inline-block;vertical-align:middle">'
    );
  }

  function getCurrencyForCountryCode(countryCode) {
    var code = (countryCode || '').toUpperCase();
    if (!code) return '';

    if (window.__trCountryCurrencies && window.__trCountryCurrencies[code]) {
      return window.__trCountryCurrencies[code];
    }

    var selectors = [
      '[data-footer-localization-select]',
      '[data-header-localization-select]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var select = document.querySelector(selectors[i]);
      if (!select) continue;
      var opt = select.querySelector('option[value="' + code + '"]');
      if (opt) {
        if (opt.getAttribute('data-currency-iso')) {
          return opt.getAttribute('data-currency-iso');
        }
        var match = (opt.textContent || '').match(/\(([A-Z]{3})/);
        if (match) return match[1];
      }
    }

    return '';
  }

  function syncCountryUI(countryCode) {
    if (!countryCode) return;
    var code = countryCode.toUpperCase();

    document.querySelectorAll('[data-header-localization-current-code]').forEach(function (target) {
      target.textContent = code;
    });

    document.querySelectorAll('[data-header-localization-current-flag]').forEach(function (target) {
      target.innerHTML = countryFlagHTML(code);
    });

    var footerFlag = document.querySelector('[data-footer-localization-flag]');
    if (footerFlag) footerFlag.innerHTML = countryFlagHTML(code);
  }

  function resolveCountryAndCurrency() {
    var data = parseGlobalEData();
    var country = null;
    var currency = null;

    if (data) {
      country = data.countryISO;
      currency = data.currencyCode;
      log('GlobalE_Data cookie', data);
    }

    if (!country) {
      try {
        country = window.localStorage.getItem(STORAGE_KEY);
      } catch (e) {}
    }

    if (!country) return null;

    country = String(country).toUpperCase();
    var expectedCurrency = getCurrencyForCountryCode(country);

    if (!currency || (expectedCurrency && currency !== expectedCurrency)) {
      log('currency mismatch', { cookie: currency, expected: expectedCurrency, country: country });
      currency = expectedCurrency || currency;
    }

    return {
      country: country,
      currency: currency
    };
  }

  function getEffectiveCountryCode() {
    var resolved = resolveCountryAndCurrency();
    return resolved ? resolved.country : null;
  }

  function getCultureForCountryCode(countryCode) {
    var code = (countryCode || '').toUpperCase();
    if (!code) return 'en-GB';

    if (window.__trCountryCultures && window.__trCountryCultures[code]) {
      return window.__trCountryCultures[code];
    }

    if (code === 'US' || code === 'CA') return 'en-' + code;
    if (code === 'GB' || code === 'GG' || code === 'JE' || code === 'IM' || code === 'IE') return 'en-GB';
    if (code === 'FR') return 'fr-FR';
    if (code === 'DE') return 'de-DE';
    if (code === 'AU') return 'en-AU';
    if (code === 'NZ') return 'en-NZ';

    return 'en-GB';
  }

  function writeGlobalEDataCookie(countryCode, currencyCode) {
    var payload = {
      countryISO: countryCode,
      currencyCode: currencyCode,
      cultureCode: getCultureForCountryCode(countryCode)
    };
    var cookieValue = encodeURIComponent(JSON.stringify(payload));
    var cookie = 'GlobalE_Data=' + cookieValue + '; path=/; max-age=31536000; SameSite=Lax';
    var domain = getCookieDomain();
    if (domain) cookie += '; domain=' + domain;

    log('write GlobalE_Data cookie', payload, domain || '(host-only)');
    document.cookie = cookie;
  }

  function dispatchCountryChange(detail) {
    try {
      window.dispatchEvent(new CustomEvent('tr:country-change', { detail: detail }));
    } catch (e) {}
  }

  function callSetUserLocalization(resolved) {
    if (!resolved || !resolved.country || !resolved.currency) return false;

    var payload = {
      countryCode: resolved.country,
      currencyCode: resolved.currency
    };

    if (window.Globale && typeof window.Globale.SetUserLocalization === 'function') {
      log('SetUserLocalization', payload);
      window.Globale.SetUserLocalization(payload);
      return true;
    }

    if (window.GlobalE && typeof window.GlobalE.SetUserLocalization === 'function') {
      log('GlobalE.SetUserLocalization', payload);
      window.GlobalE.SetUserLocalization(payload);
      return true;
    }

    return false;
  }

  function refreshGlobalEPrices() {
    var resolved = resolveCountryAndCurrency();
    if (!resolved || !resolved.currency) return;

    if (callSetUserLocalization(resolved)) return;

    var globale = window.Globale || window.GlobalE;
    if (!globale) return;

    if (globale.PriceConversion && typeof globale.PriceConversion.convertAllPrices === 'function') {
      log('PriceConversion.convertAllPrices');
      globale.PriceConversion.convertAllPrices();
    } else if (typeof globale.refreshPrices === 'function') {
      log('refreshPrices');
      globale.refreshPrices();
    }
  }

  function waitForGlobale(callback, maxAttempts) {
    var attempts = 0;
    var limit = maxAttempts || 80;
    var timer = setInterval(function () {
      attempts++;
      if (window.Globale || window.GlobalE || attempts >= limit) {
        clearInterval(timer);
        callback(window.Globale || window.GlobalE || null);
      }
    }, 100);
  }

  window.trIsGlobalEActive = isGlobalEActive;
  window.trGetEffectiveCountryCode = getEffectiveCountryCode;
  window.trSyncCountryUI = syncCountryUI;

  // Persist preference locally and sync UI. Always returns false so the caller
  // submits the Shopify localization form — Global-e hooks that pipeline to set
  // cookies and convert storefront prices.
  window.trApplyCountryChange = function (countryCode, source) {
    var code = String(countryCode || '').toUpperCase();
    if (!code) return false;

    var currencyCode = getCurrencyForCountryCode(code);
    log('persist country change', { country: code, currency: currencyCode, source: source || 'unknown' });

    try {
      window.localStorage.setItem(STORAGE_KEY, code);
      window.sessionStorage.removeItem(REPAIR_SESSION_KEY);
    } catch (e) {}

    if (currencyCode) {
      writeGlobalEDataCookie(code, currencyCode);
    }

    syncCountryUI(code);
    dispatchCountryChange({
      countryCode: code,
      source: source || 'unknown'
    });

    return false;
  };

  function bootstrapGlobalEParams() {
    var resolved = resolveCountryAndCurrency();
    if (!resolved || !resolved.country) return;

    window.GLBE_PARAMS = {
      countryCode: resolved.country,
      currencyCode: resolved.currency || '',
      isExternal: true
    };

    log('GLBE_PARAMS bootstrap', window.GLBE_PARAMS);

    var data = parseGlobalEData();
    if (
      resolved.currency &&
      data &&
      (data.countryISO !== resolved.country || data.currencyCode !== resolved.currency)
    ) {
      var repairToken = resolved.country + ':' + resolved.currency;
      var alreadyRepaired = false;

      try {
        alreadyRepaired = window.sessionStorage.getItem(REPAIR_SESSION_KEY) === repairToken;
      } catch (e) {}

      if (!alreadyRepaired) {
        try {
          window.sessionStorage.setItem(REPAIR_SESSION_KEY, repairToken);
        } catch (e) {}
        writeGlobalEDataCookie(resolved.country, resolved.currency);
        log('repairing GlobalE_Data cookie, reloading');
        window.location.reload();
      }
    }
  }

  function initCountryUI() {
    var resolved = resolveCountryAndCurrency();
    log('init', {
      globalE: isGlobalEActive(),
      resolved: resolved ? resolved.country + '/' + resolved.currency : '(none)'
    });

    if (!resolved || !resolved.country) return;

    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored !== resolved.country) {
        window.localStorage.setItem(STORAGE_KEY, resolved.country);
      }
    } catch (e) {}

    syncCountryUI(resolved.country);

    document.querySelectorAll('[data-footer-localization-select], [data-header-localization-select]').forEach(function (select) {
      if (select.querySelector('option[value="' + resolved.country + '"]')) {
        select.value = resolved.country;
      }
    });

    if (isGlobalEActive()) {
      waitForGlobale(function () {
        log('Globale ready — refreshing prices');
        refreshGlobalEPrices();

        var ukMarketCodes = ['GB', 'GG', 'JE', 'IM'];
        if (ukMarketCodes.indexOf(resolved.country) === -1 && resolved.currency && resolved.currency !== 'GBP') {
          setTimeout(function () {
            var priceEl = document.querySelector('.js-form-price, [data-ge-price]');
            if (!priceEl || !/£/.test(priceEl.textContent || '')) return;

            var reloadKey = 'tr_ge_price_reload:' + resolved.country + ':' + resolved.currency;
            var alreadyReloaded = false;

            try {
              alreadyReloaded = window.sessionStorage.getItem(reloadKey) === '1';
            } catch (e) {}

            if (alreadyReloaded) {
              log('prices still GBP after reload attempt', resolved);
              return;
            }

            try {
              window.sessionStorage.setItem(reloadKey, '1');
            } catch (e) {}

            log('prices still GBP — reloading for Global-e conversion', resolved);
            window.location.reload();
          }, 3000);
        }
      });
    }
  }

  bootstrapGlobalEParams();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountryUI);
  } else {
    initCountryUI();
  }
})();
